module.exports = __webpack_public_path__ + "img/close.7d170ab9.svg";